var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAction, createReducer } from '@reduxjs/toolkit';
import * as statuses from '../../states';
import * as types from './types';
var initialState = {
    status: statuses.IDLE,
    ownProjects: [],
    investmentProjects: [],
};
var fetch = createAction(types.PROJECT_FETCH_REQUEST);
var fetchSuccess = createAction(types.PROJECT_FETCH_SUCCESS);
var fetchFail = createAction(types.PROJECT_FETCH_FAIL);
var projectReducer = createReducer(initialState, function (builder) {
    builder
        .addCase(fetch, function (state) { return (__assign(__assign({}, state), { status: statuses.LOADING })); })
        .addCase(fetchSuccess, function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { status: statuses.SUCCESS, ownProjects: payload.ownProjects, investmentProjects: payload.investmentProjects }));
    })
        .addCase(fetchFail, function (state) { return (__assign(__assign({}, state), { status: statuses.FAIL })); });
});
export default projectReducer;
